/**
 * Chat scroll helpers — scroll inside the message container only.
 * Avoid scrollIntoView() on message anchors; it often scrolls the whole page.
 */

export const NEAR_BOTTOM_THRESHOLD_PX = 80;

export function isNearBottom(container, threshold = NEAR_BOTTOM_THRESHOLD_PX) {
  if (!container) return true;
  const { scrollTop, scrollHeight, clientHeight } = container;
  return scrollHeight - scrollTop - clientHeight <= threshold;
}

/**
 * @param {HTMLElement | null} container
 * @param {'auto' | 'smooth'} [behavior]
 */
export function scrollContainerToBottom(container, behavior = 'auto') {
  if (!container) return;
  const top = container.scrollHeight;
  if (behavior === 'smooth' && typeof container.scrollTo === 'function') {
    container.scrollTo({ top, behavior: 'smooth' });
  } else {
    container.scrollTop = top;
  }
}
